<div class="main-container">
  <div class="container-top">
    <div class="container-top-left">
      <div class="container-header">
        <ngb-alert *ngIf=noPrivilege [type]="'warning'" [dismissible]="false" class="resize" style="background-color: #FFF3CD; color: #A56404;">
          <p>
            NO ROLE IS ASSIGNED TO YOU, SO YOU CAN'T ACCESS ANY TASK !!
          </p>
        </ngb-alert>
        <p><i class="bi bi-buildings-fill"></i> Entity Registration Data Entry</p>
        <ngb-alert *ngIf=errorStatus [type]="'danger'" [dismissible]="false" class="resize" style="background-color: #ffc6c6;
                color: #6a0000;
                justify-content: center;
                display: grid;">
          <p>YOU ARE CURRENTLY OFFLINE !!</p>
        </ngb-alert>

      </div>
      <div class="de-statistics-container" *ngIf=PRE_DATA_ENTRY>
          <a class="de-stats-link" [routerLink]="'/company-registration/company-not-submitted'">
            <div class="de-statistics">
              <app-progress-spinner [isLoading]="loadingCR" [classes]="'text-black mr-1'">
              </app-progress-spinner>
              <h1 class="de-progress" *ngIf="!loadingCR && companyRegistrationStatistics">{{companyRegistrationStatistics.notSubmitted}}</h1>
              <hr>
              <span><i class="bi bi-bar-chart-line-fill"></i> Not Submitted</span>
            </div>
          </a>
          <a class="de-stats-link" [routerLink]="'/company-registration/company-list'">
            <div class="de-statistics">
              <app-progress-spinner [isLoading]="loadingCR" [classes]="'text-black mr-1'">
              </app-progress-spinner>
              <h1 class="de-completed" *ngIf="!loadingCR && companyRegistrationStatistics">{{companyRegistrationStatistics.pending}}</h1>
              <hr>
              <span><i class="bi bi-bar-chart-line-fill"></i> Completed App.</span>
            </div>
          </a>
          <a class="de-stats-link" [routerLink]="'/escalated-application/escalated'">
            <div class="de-statistics">
              <app-progress-spinner [isLoading]="loadingCR" [classes]="'text-black mr-1'">
              </app-progress-spinner>
              <h1 class="de-danger" *ngIf="!loadingCR && companyRegistrationStatistics">{{companyRegistrationStatistics.escalatedApp}}</h1>
              <hr>
              <span><i class="bi bi-bar-chart-line-fill"></i> Escalated App.</span>
            </div>
          </a>
      </div>
      <div class="de-reg-container">
        <a *ngIf="PRE_DATA_ENTRY" [routerLink]="'/company-registration/new-application'" class="pre-links" (click)="newEntry()">
          <button class="btn new-entry">
            <i class="bi bi-plus-square-fill"></i> NEW ENTRY
          </button>
        </a>

        <a *ngIf="PRE_DATA_ENTRY && canUpdateCompany" class="pre-links" routerLink="/company-registration/company-update" (click)=update()>
          <button class="btn new-entry">
            <i class="bi bi-arrow-up-square-fill"></i> UPDATE
          </button>
        </a>
        <a *ngIf="SUPERVISOR" class="pre-links" [routerLink]="'/escalated-application/escalated'" (click)=escalated()>
          <button class="btn escalated">
            <i class="bi bi-bar-chart-line-fill"></i> ESCALATED
          </button>
        </a>



      </div>
    </div>
  </div>
  <div class="container-bottom">
    <div class="container-top-right">
      <div class="container-header">
        <!--        <span>Entity Registration Data Entry</span>-->
        <p><i class="bi bi-buildings-fill"></i> Entity Post Inc Data Entry</p>

      </div>
      <div class="de-statistics-container" *ngIf="(postIncStat$ | async) as postIncStat">
        <a *ngIf=PRE_DATA_ENTRY class="de-stats-link" [routerLink]="'/post-incorporation/menu-assign-page'">
          <div class="de-statistics">
            <app-progress-spinner [isLoading]="loadingCR" [classes]="'text-black mr-1'">
            </app-progress-spinner>
            <h1 class="de-progress" *ngIf="!loadingCR && companyRegistrationStatistics">{{postIncStat.dataEntryCount}}</h1>
            <hr>
            <span><i class="bi bi-bar-chart-line-fill"></i> In Progress</span>
          </div>
        </a>
        <a *ngIf=SUPERVISOR class="de-stats-link" [routerLink]="'/post-incorporation/supervision'">
          <div class="de-statistics">
            <app-progress-spinner [isLoading]="loadingCR" [classes]="'text-black mr-1'">
            </app-progress-spinner>
            <h1 class="de-supervision" *ngIf="!loadingCR && companyRegistrationStatistics">{{postIncStat.supervisorCount}}</h1>
            <hr>
            <span><i class="bi bi-bar-chart-line-fill"></i> Supervision</span>
          </div>
        </a>
        <a *ngIf=PRE_DATA_ENTRY class="de-stats-link">
          <div class="de-statistics">
            <app-progress-spinner [isLoading]="loadingCR" [classes]="'text-black mr-1'">
            </app-progress-spinner>
            <h1 class="de-completed" *ngIf="!loadingCR && companyRegistrationStatistics">{{postIncStat.approvedCount}}</h1>
            <hr>
            <span><i class="bi bi-bar-chart-line-fill"></i> Approved</span>
          </div>
        </a>
      </div>
      <div class="de-reg-container">
        <a class="post-links" *ngIf=POST_DATA_ENTRY [routerLink]="'/post-incorporation/menu-tab'" (click)=postInc()>
          <button class="btn new-entry-post">
            <i class="bi bi-plus-square-fill"></i> POST INCORPORATION
          </button>
        </a>
      </div>
    </div>
  </div>






</div>


<!--<div class="app-content ui basic segment container min">-->
<!--  <div class="full-width ui basic segment">-->

<!--    <div class="ui grid">-->
<!--      <div class="row">-->

<!--        <div class="eleven wide column">-->
<!--          <div class="activity-summary">-->
<!--            <div class="full-width ui basic segment">-->

<!--              &lt;!&ndash; <app-breadcrumb></app-breadcrumb> &ndash;&gt;-->

<!--              <div class="ui hidden divider"></div>-->

<!--              <div class="full-width ui basic segment bounceInLeft">-->
<!--                <div class="ui message" style="-->
<!--                display: flex;-->
<!--                justify-content: center;">-->
<!--                  <div class="header">-->
<!--                    Company/Business Name/Incorporated Trustee-->
<!--                  </div>-->
<!--                  <br>-->
<!--                  <ngb-alert *ngIf=noPrivilege [type]="'warning'" [dismissible]="false" class="resize"-->
<!--                    style="background-color: #FFF3CD; color: #A56404;">-->
<!--                    <p>-->
<!--                      NO ROLE IS ASSIGNED TO YOU, SO YOU CAN'T ACCESS ANY TASK !!-->
<!--                    </p>-->
<!--                  </ngb-alert>-->




<!--                  &lt;!&ndash; <p>Start registration with your Name Availability Code-->
<!--                    <a [routerLink]="'/company-registration/new-application'">here</a>.</p> &ndash;&gt;-->
<!--                </div>-->

<!--                <h3 class="ui horizontal divider header">-->
<!--                  <a>Entity Registration Data Entry</a>-->
<!--                </h3>-->

<!--                <ngb-alert *ngIf=errorStatus [type]="'danger'" [dismissible]="false" class="resize" style="background-color: #ffc6c6;-->
<!--                color: #6a0000;-->
<!--                justify-content: center;-->
<!--                display: grid;">-->
<!--                  <p>-->
<!--                    YOU ARE CURRENTLY OFFLINE !!-->
<!--                  </p>-->
<!--                </ngb-alert>-->


<!--                <div class="ui centered stackable grid" *ngIf=PRE_DATA_ENTRY>-->
<!--                  <div class="four wide column">-->
<!--                    <a class="statistic ui segment" [routerLink]="'/company-registration/company-not-submitted'">-->
<!--                      <div class="value">-->
<!--                        <app-progress-spinner [isLoading]="loadingCR" [classes]="'text-black mr-1'">-->
<!--                        </app-progress-spinner>-->

<!--                        <span-->
<!--                          *ngIf="!loadingCR && companyRegistrationStatistics">{{companyRegistrationStatistics.notSubmitted}}</span>-->
<!--                      </div>-->
<!--                      <div class="label">-->
<!--                        Not Submitted-->
<!--                      </div>-->
<!--                    </a>-->
<!--                  </div>-->

<!--                  <div class="four wide column">-->
<!--                    <a class="statistic ui segment" [routerLink]="'/company-registration/company-list'">-->
<!--                      <div class="value">-->
<!--                        <app-progress-spinner [isLoading]="loadingCR" [classes]="'text-black mr-1'">-->
<!--                        </app-progress-spinner>-->

<!--                        <span-->
<!--                          *ngIf="!loadingCR && companyRegistrationStatistics">{{companyRegistrationStatistics.pending}}</span>-->
<!--                      </div>-->
<!--                      <div class="label">-->
<!--                        Completed App.-->
<!--                      </div>-->
<!--                    </a>-->
<!--                  </div>-->

<!--                  <div class="four wide column">-->
<!--                    <a class="statistic ui segment" [routerLink]="'/escalated-application/escalated'">-->
<!--                      <div class="value">-->
<!--                        <app-progress-spinner [isLoading]="loadingCR" [classes]="'text-black mr-1'">-->
<!--                        </app-progress-spinner>-->

<!--                        <span-->
<!--                          *ngIf="!loadingCR && companyRegistrationStatistics">{{companyRegistrationStatistics.escalatedApp}}</span>-->
<!--                      </div>-->
<!--                      <div class="label">-->
<!--                        Escalated App.-->
<!--                      </div>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  &lt;!&ndash; <div class="four wide column"  [disabled]="'true'">-->
<!--                    <a  class="statistic ui segment" [routerLink]="'/company-registration/company-approved'">-->
<!--                      <div class="value">-->
<!--                        <app-progress-spinner [isLoading]="loadingCR" [classes]="'text-black mr-1'">-->
<!--                        </app-progress-spinner>-->
<!--                        <span-->
<!--                          *ngIf="!loadingCR && companyRegistrationStatistics">{{companyRegistrationStatistics.approved}}</span>-->
<!--                      </div>-->
<!--                      <div class="label">-->
<!--                        Approved-->
<!--                      </div>-->
<!--                    </a>-->
<!--                  </div> &ndash;&gt;-->

<!--                </div>-->


<!--                <div class="ui center aligned basic segment ">-->
<!--                  <a *ngIf=PRE_DATA_ENTRY class="ui primary button"-->
<!--                    [routerLink]="'/company-registration/new-application'" style="margin:8px 5px; padding: 15px 40px;"-->
<!--                    (click)=newEntry()>-->
<!--                    <i style="font-size:medium;" class="fa fa-spinner fa-spin" *ngIf="newEntryLoader"></i>-->
<!--                    New Entry</a>-->



<!--                  <a *ngIf=PRE_DATA_ENTRY-->
<!--                    style="background-color: rgb(243, 117, 33) ;color:rgb(248, 246, 246); padding: 15px 40px;"-->
<!--                    class="ui primary button" routerLink="/company-registration/company-update/{{12233}}" (click)=update()>-->
<!--                    <i style="font-size:medium;" class="fa fa-spinner fa-spin" *ngIf="updateLoader"></i>-->
<!--                    Update </a>-->

<!--                  <a *ngIf=SUPERVISOR style="background-color: #555353 ;color:rgb(248, 246, 246); padding: 15px 40px;"-->
<!--                    class="ui primary button" [routerLink]="'/escalated-application/escalated'" (click)=escalated()>-->
<!--                    <i style="font-size:medium;" class="fa fa-spinner fa-spin" *ngIf="escalatedAppLoader"></i>-->
<!--                    Escalated App. </a>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="ui hidden divider"></div>-->


<!--              <div class="bounceInLeft">-->

<!--                <h3 class="ui horizontal divider header">-->
<!--                  <a>Entity Post Inc. Data Entry</a>-->
<!--                </h3>-->

<!--                <div class="ui centered stackable grid" *ngIf="(postIncStat$ | async) as postIncStat">-->

<!--                  &lt;!&ndash; [routerLink]="'/post-incorporation/supervision'" &ndash;&gt;-->
<!--                  <div class="four wide column" *ngIf=PRE_DATA_ENTRY>-->
<!--                    <a [routerLink]="'/post-incorporation/menu-assign-page'" class="statistic ui segment">-->
<!--                      <div class="value">-->
<!--                        <app-progress-spinner [isLoading]="loadingCR" [classes]="'text-black mr-1'">-->
<!--                        </app-progress-spinner>-->

<!--                        <span *ngIf="!loadingCR && companyRegistrationStatistics">-->
<!--                          &lt;!&ndash; {{companyRegistrationStatistics.pending}} &ndash;&gt;-->
<!--                          {{postIncStat.dataEntryCount}}-->
<!--                        </span>-->
<!--                      </div>-->
<!--                      <div class="label">-->
<!--                        In Progress-->
<!--                      </div>-->
<!--                    </a>-->
<!--                  </div>-->


<!--                  <div class="four wide column" *ngIf=SUPERVISOR>-->
<!--                    <a [routerLink]="'/post-incorporation/supervision'" class="statistic ui segment">-->
<!--                      <div class="value">-->
<!--                        <app-progress-spinner [isLoading]="loadingCR" [classes]="'text-black mr-1'">-->
<!--                        </app-progress-spinner>-->
<!--                        <span *ngIf="!loadingCR && companyRegistrationStatistics">-->
<!--                          &lt;!&ndash; {{companyRegistrationStatistics.approved}} &ndash;&gt;-->
<!--                          {{postIncStat.supervisorCount}}-->

<!--                        </span>-->
<!--                      </div>-->
<!--                      <div class="label">-->
<!--                        Supervision-->
<!--                      </div>-->
<!--                    </a>-->
<!--                  </div>-->

<!--                  &lt;!&ndash; [routerLink]="'/company-registration/company-approved'" &ndash;&gt;-->
<!--                  <div class="four wide column" *ngIf=PRE_DATA_ENTRY>-->
<!--                    <a class="statistic ui segment">-->
<!--                      <div class="value">-->
<!--                        <app-progress-spinner [isLoading]="loadingCR" [classes]="'text-black mr-1'">-->
<!--                        </app-progress-spinner>-->
<!--                        <span *ngIf="!loadingCR && companyRegistrationStatistics">-->
<!--                          &lt;!&ndash; {{companyRegistrationStatistics.approved}} &ndash;&gt;-->
<!--                          {{postIncStat.approvedCount}}-->

<!--                          &lt;!&ndash; 0 &ndash;&gt;-->
<!--                        </span>-->
<!--                      </div>-->
<!--                      <div class="label">-->
<!--                        Approved-->
<!--                      </div>-->
<!--                    </a>-->
<!--                  </div>-->



<!--                </div>-->

<!--                <div class="ui center aligned basic segment ">-->

<!--                  <a *ngIf=POST_DATA_ENTRY-->
<!--                    style="background-color: rgb(243, 236, 33) ;color:rgb(64, 62, 62); padding: 15px 30px;"-->
<!--                    class="ui danger button" [routerLink]="'/post-incorporation/menu-tab'" (click)=postInc()>-->
<!--                    <i style="font-size:medium;" class="fa fa-spinner fa-spin" *ngIf="postIncLoader"></i>-->

<!--                    PostIncorporation </a>-->
<!--                </div>-->


<!--              </div>-->

<!--            </div>-->

<!--          </div>-->
<!--        </div>-->


<!--      </div>-->

<!--    </div>-->
<!--  </div>-->
